import { jsx as _jsx } from "react/jsx-runtime";
import pentagonUrl from '../../../assets/gems/pentagon.svg?inline';
export function Pentagon({ ...props }) {
    return _jsx("img", { ...props, src: pentagonUrl, alt: 'PentagonImage' });
}
